import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import {
  OneClickPaymentProvider,
  OneClickHasResultProvider,
  OneClickNoResultProvider,
} from '../../../../providers/order/one-click-payment.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickStandardLotProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-standard-lot.provider';
import { OneClickLocationDisplayer } from '../../../../providers/order/one-click-multiple-jobsite-displayer.provider';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';
import { FormInputTimeComponent } from '../../../../../shared/modules/configurable-form/components/form-input-time/form-input-time.component';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { FieldInputTimeConfig } from '../../../../../../modules/shared/modules/configurable-form/models/field-configs/field-input-time-config.interface';
import { TimepickerHourFormat } from '../../../../../../modules/shared/components/cmx-timepicker/cmx-timepicker.component';
import { MINUTE_STEP_PL } from '../../../../../../modules/order-builder/modules/specification/configs/pl/constants';
import { Validators } from '@angular/forms';
import { OneClickSetRequestedDateTime } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-requested-date-time.command.service';
import { OneClickRequestedTimeProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-requested-time.provider';
import { OneClickFeatureConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-feature-config';
import { OneClickElement } from '@ordersnproducts/modules/one-click-order/util/enums/one-click-element';
import { OneClickElementConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-element-config';
import { FormSeparatorComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-separator/form-separator.component';
import { OneClickMultipleOption } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-is-multiple-option.provider';
import * as moment from 'moment';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagjobsite',
    dataTIdValue: 'cmx-createoneclickorder-lblvaljobsite',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PointOfDelivery,
    label: 'views.one_click.pod',
    hidden: OneClickLocationDisplayer.HidePointOfDelivery,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpointofdelivery',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpointofdelivery',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    dataTIdLabel: 'cmx-createoneclickorder-lbltagproduct',
    dataTIdValue: 'cmx-createoneclickorder-lblvalproduct',
    containerClassNames: ['col-md-6 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Quantity,
    text: OneClickStandardLotProvider,
    dataTIdLabel: 'cmx-createoneclickorder-lbltagquantity',
    dataTIdValue: 'cmx-createoneclickorder-lblvalquantity',
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-3 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    text: OneClickPaymentProvider,
    label: 'views.one_click.payment_method',
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpayment',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpayment',
  } as FieldLabelConfig,
  {
    type: FormInputTimeComponent,
    label: 'views.one_click.request_time',
    name: OneClickPreviewField.Time,
    containerClassNames: ['col-md-4  text-capitalize retail-control'],
    hourFormat: TimepickerHourFormat.format24,
    minuteStep: MINUTE_STEP_PL,
    min: moment()
      .utcOffset(0)
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
    onChange: [OneClickSetRequestedDateTime],
    validation: [Validators.required],
    hidden: OneClickHasResultProvider,
  } as FieldInputTimeConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Time,
    hidden: OneClickNoResultProvider,
    text: OneClickRequestedTimeProvider,
    label: 'views.one_click.request_time',
    containerClassNames: ['col-md-4 text-capitalize'],
  } as FieldLabelConfig,
  {
    type: FormSeparatorComponent,
    name: '',
    containerClassNames: ['col-md-12'],
    hidden: OneClickHasResultProvider,
    visible: OneClickMultipleOption.IsSingleOption,
  } as FieldConfig,
];

export const features: OneClickFeatureConfig = {
  [OneClickElement.TERMS_AND_CONDITIONS]: {
    name: OneClickElement.TERMS_AND_CONDITIONS,
  } as OneClickElementConfig,
};
